// extracted by mini-css-extract-plugin
export var wrapper = "Select-module--wrapper--k3Psn";
export var itemsList = "Select-module--itemsList--ckzd-";
export var dropDownIconWrapper = "Select-module--dropDownIconWrapper--Vo7G5";
export var isOpen = "Select-module--isOpen--fbHnc";